import { Card } from "flowbite-react";
import { FiRefreshCw } from "react-icons/fi";

const getErrorMessage = (status) => {
  switch (status) {
    case 402:
      return {
        title: "Créditos insuficientes",
        message:
          "Você não tem créditos suficientes para esta operação. 💸 Adicione mais créditos para continuar.",
      };
    case 403:
      return {
        title: "Acesso negado",
        message:
          "Você atingiu seu limite mensal ou não tem permissão para realizar esta consulta. 🔐",
      };
    case 404:
      return {
        title: "Consulta ou empresa não encontrada",
        message:
          "Não conseguimos localizar os dados informados. Verifique as informações e tente novamente. 🔍",
      };
    case 500:
      return {
        title: "Ops! Algo deu errado",
        message:
          "Não conseguimos concluir sua consulta. 😕 " +
          "Pode ter sido uma instabilidade temporária. " +
          "Também pode acontecer quando o CPF/CNPJ é muito recente " +
          "ou quando se trata de uma Pessoa Politicamente Exposta (PEP).",
      };
    default:
      return {
        title: "Ops! Algo deu errado",
        message:
          "Não conseguimos concluir sua consulta. 😕 " +
          "Pode ter sido uma instabilidade temporária. " +
          "Também pode acontecer quando o CPF/CNPJ é muito recente " +
          "ou quando se trata de uma Pessoa Politicamente Exposta (PEP).",
      };
  }
};

const ErrorQuery = ({ status }) => {
  const { title, message } = getErrorMessage(status);

  return (
    <Card className="flex items-center justify-center p-4 mt-4">
      <div className="flex flex-col items-center text-center space-y-4">
        <div className="bg-yellow-100 p-4 rounded-full">
          <FiRefreshCw className="w-5 h-5 md:w-10 md:h-10 text-yellow-500" />
        </div>
        <h2 className="text-lg md:text-2xl font-bold text-gray-800">{title}</h2>
        <p className="text-gray-600 text-sm md:text-base">
          {message}
          <br />
          <b className="block mt-4">
            Que tal tentar novamente em instantes? 🔄
          </b>
        </p>
      </div>
    </Card>
  );
};

export default ErrorQuery;
